import $ from "jquery";
import config from './lib/config';

// Components.
// import './components/ResponsiveMenu';
import './components/Colorbox';
import './components/Webflow';

export default class App {


    /**
     * init - Initialize the app
     * @return {void} Not meant to return
     */
    static init() {

    	document.documentElement.className = "js";

    }

}

$(document).ready(function(){

	App.init();

});